import React from 'react'

interface State { hasError: boolean; error?: Error }

export default class ErrorBoundary extends React.Component<{children: React.ReactNode}, State> {
  constructor(props: any) { super(props); this.state = { hasError: false } }
  static getDerivedStateFromError(error: Error) { return { hasError: true, error } }
  componentDidCatch(error: Error, info: any) { console.error('React Error:', error, info) }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#f8fafc', padding:'20px' }}>
          <div style={{ background:'white', borderRadius:'12px', padding:'32px', maxWidth:'500px', width:'100%', boxShadow:'0 4px 24px rgba(0,0,0,0.1)' }}>
            <h1 style={{ color:'#dc2626', fontSize:'18px', fontWeight:700, marginBottom:'8px' }}>เกิดข้อผิดพลาด</h1>
            <p style={{ color:'#6b7280', fontSize:'14px', marginBottom:'16px' }}>{this.state.error?.message || 'Unknown error'}</p>
            <pre style={{ background:'#f3f4f6', borderRadius:'8px', padding:'12px', fontSize:'11px', overflow:'auto', maxHeight:'200px', color:'#374151' }}>
              {this.state.error?.stack?.slice(0, 500)}
            </pre>
            <button onClick={() => window.location.reload()}
              style={{ marginTop:'16px', background:'#2563eb', color:'white', border:'none', borderRadius:'8px', padding:'8px 16px', cursor:'pointer', fontSize:'14px' }}>
              รีโหลดหน้า
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
